

export class DateHelper {
    public static readonly soapDateTimePattern: string = 'YYYY-MM-DD HH:mm:ss';
    public static readonly soapDatePattern: string = 'YYYY-MM-DD';

    static  soapDateTimeToMoment(soapDate: string): moment.Moment {
        let momentDate = moment(soapDate, this.soapDateTimePattern);
        return momentDate;
    }

    static soapDateToMoment(soapDate: string): moment.Moment {
        let momentDate = moment(soapDate, this.soapDatePattern);
        return momentDate;
    }


}